import { useState } from "react";
import Icon from "../Icon";
import { BtnPrimary } from "../Atoms";
import Campo from "./Campo";

// Los dos sentidos del protocolo, en un solo formulario: guardar un proyecto
// como protocolo, y arrancar un proyecto desde uno.
//
// Van juntos porque preguntan lo mismo —un nombre y un departamento— y difieren
// solo en lo que hay que explicar. Separarlos habria duplicado el formulario
// para cambiar tres cadenas de texto.
export default function ProtocoloForm({
  modo,               // "guardar" | "usar"
  origen,             // el proyecto del que se parte, o el protocolo que se usa
  // Cuantos pasos se lleva la copia. Va aparte y no se saca de `origen` porque
  // el numero vive en sitios distintos segun de donde venga: el listado trae un
  // contador agregado en `tareas`, y el detalle trae el array entero. Leer una
  // sola de las dos formas hacia que el formulario dijera "0 paso(s)" desde el
  // detalle, que es justo desde donde se guarda un protocolo.
  pasos = 0,
  teams = [], inS, lbS, onSave, onClose,
}) {
  const guardar = modo === "guardar";
  const [name, setName]     = useState(guardar ? `${origen?.name || ""} (protocolo)` : (origen?.name || ""));
  const [teamId, setTeamId] = useState(origen?.team_id ? String(origen.team_id) : "");
  const [enviando, setEnviando] = useState(false);

  const enviar = async () => {
    const limpio = name.trim();
    if (!limpio || enviando) return;
    setEnviando(true);
    // El estado de envio NO se levanta al terminar: quien llama cierra el modal,
    // y levantarlo antes deja un instante en el que se puede pulsar dos veces.
    await onSave({ name: limpio, team_id: teamId || null });
  };

  return (
    <div>
      <div data-titulo="1" style={{ fontWeight: 800, fontSize: 16, marginBottom: 6, color: "var(--text)",
        display: "flex", alignItems: "center", gap: 8 }}>
        <Icon name="journal-text" size={15} color="var(--text3)" />
        {guardar ? "Guardar como protocolo" : "Crear un proyecto desde este protocolo"}
      </div>

      <div style={{ fontSize: 12.5, color: "var(--text3)", lineHeight: 1.6, marginBottom: 16 }}>
        {guardar ? (
          <>
            Se copian los <b>{pasos} paso(s)</b> de «{origen?.name}», sus conexiones, la
            colocación del lienzo, las estimaciones y quién hace cada cosa.
            {" "}No se copia nada de la ejecución: ni fechas, ni estados, ni progreso, ni las
            horas del cuaderno. El proyecto original se queda como está.
          </>
        ) : (
          <>
            Nace un proyecto nuevo con los <b>{pasos} paso(s)</b> del protocolo, sus conexiones
            y sus responsables ya puestos, todos en Pendiente.
            {" "}<b>Sin fechas</b>: un protocolo sabe cuánto cuesta cada paso, pero no cuándo
            toca, así que el calendario lo pones tú. El protocolo no se toca.
          </>
        )}
      </div>

      <div className="cw-field" style={{ marginBottom: 12 }}>
        <Campo><label style={lbS}>Nombre</label>
        <input style={inS} value={name} autoFocus
          onChange={e => setName(e.target.value)}
          onKeyDown={e => e.key === "Enter" && enviar()} /></Campo>
      </div>

      <div className="cw-field" style={{ marginBottom: 18 }}>
        <Campo><label style={lbS}>Departamento</label>
        <select style={{ ...inS, cursor: "pointer" }} value={teamId}
          onChange={e => setTeamId(e.target.value)}>
          {/* Sin departamento, un protocolo lo ve toda la casa. Se dice aqui
              porque es la diferencia entre compartirlo y esconderlo. */}
          <option value="">{guardar ? "De toda la casa" : "Sin departamento"}</option>
          {teams.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
        </select></Campo>
        {guardar && !teamId && (
          <div style={{ fontSize: 10.5, color: "var(--text3)", marginTop: 4 }}>
            Cualquiera podrá verlo y usarlo. Con departamento, solo los suyos.
          </div>
        )}
      </div>

      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <button className="btn" onClick={onClose}
          style={{ padding: "8px 16px", borderRadius: 9, border: "1px solid var(--border)",
            cursor: "pointer", fontSize: 13, background: "var(--surface2)",
            color: "var(--text2)", fontFamily: "var(--font)" }}>Cancelar</button>
        <BtnPrimary onClick={enviar} disabled={!name.trim() || enviando}>
          <Icon name={guardar ? "floppy2-fill" : "plus-lg"} size={11} color="#fff" />
          {enviando ? "Creando..." : (guardar ? "Guardar protocolo" : "Crear proyecto")}
        </BtnPrimary>
      </div>
    </div>
  );
}
